'use strict';

const $ = require('jquery');
const util = require('../../utils/util');
const dytracking = require('../tracking/dytracking');

const timer = {
    id: null,
    clear: function () {
        if (this.id) {
            window.clearTimeout(this.id);
            delete this.id;
        }
    },
    start: function (duration, callback) {
        this.id = setTimeout(callback, duration);
    }
};
let minicart;

/**
 * @description applies Mini-Cart handler
 */
const setMiniCartHandler = function () {
    $('a.mini-cart-link').on('mouseenter', fetchMiniCartItems);

    $('.header-add-to-cart-confirm').on('click', '.continue-shopping', function (e) {
        e.preventDefault();
        minicart.closeConfirmation();
    });

    $(window).on('click', function (e) {
        if (minicart.confirmationShown && !$.contains($('.header-add-to-cart-confirm')[0], e.target)) {
            minicart.closeConfirmation();
        }
    });

    $('.nav-item-cart .menus-flyout-arrow-wrapper').on('keydown', function (event) {
        // Space or Enter
        if (event.keyCode === 32 || event.keyCode === 13) {
            fetchMiniCartItems();
        }
    });
};

/**
 * @description Initializes the removal functionality for mini cart items.
 */
function initializeMiniCartRemoval() {
    const $miniCart = $('.mini-cart');
    const $deleteItems = $miniCart.find('a.remove-product');

    if (!$deleteItems.length) {
        return;
    }

    $deleteItems.off('click').on('click', function (e) {
        e.preventDefault();
        minicart.removeFromCart($(this));
    });
}

/**
 * @description Fetches mini cart items and updates the mini cart element.
 */
function fetchMiniCartItems() {
    const $miniCartEl = $('#ajax-minicart');
    const getMiniCartItemsUrl = $miniCartEl.data('ajax-url');

    $.ajax({
        url: getMiniCartItemsUrl,
        data: {
            onlyFlyout: true
        }
    })
        .done(function (res) {
            $miniCartEl.html(res);
            initializeMiniCartRemoval();
        })
        .fail(function () {
            /**
             * @TODO No UX requirements for this case at the moment
             */
            $miniCartEl.html('');
        });
}

minicart = {
    init: function () {
        this.$el = $('.mini-cart');
        this.$content = this.$el.find('.mini-cart-flyout');
        this.delay = 400;
        this.confirmationShown = false;
        setMiniCartHandler();
    },
    /**
     * @function
     * @description Updates the mini cart without opening it
     */
    update: function (html, options) {
        var theOptions = options || {};
        theOptions['suppressCart'] = true;
        this.show(html, theOptions);
    },
    /**
     * @function
     * @description Shows the given content in the mini cart
     * @param {String} A HTML string with the content which will be shown
     */
    show: function (html, options) {
        var theOptions = options || {};
        this.$el.html(html);
        // util.scrollBrowser(0);
        this.init();
        this.updateMobileQty(theOptions.qty);
        this.slide(theOptions);
        // this.open();
    },
    /**
     * @function
     * @description Slides down and show the contents of the mini cart
     */
    slide: function (options) {
        if (!options.suppressCart) {
            this.open();
        }
        timer.start(2500, this.close.bind(this, options));
    },

    /**
     * @function
     * @description Simply open the mini cart with
     * @param {Number} delay The delay in milliseconds
     */
    open: function () {
        timer.clear();
        this.$content.closest('.header-menu-item').addClass('active');
    },

    /**
     * @function
     * @description Closes the mini cart with given delay
     * @param {Number} delay The delay in milliseconds
     */
    close: function (options) {
        timer.clear();
        // hide the item using CSS class

        this.$content.closest('.header-menu-item').removeClass('active');
        if (!options || !options.keepOpen) {
            this.closeConfirmation();
        }
    },

    closeConfirmation: function () {
        var $confirmationDiv = $('.header-add-to-cart-confirm');
        var $overlayDiv = $('.header-add-to-cart-confirm-overlay');
        $confirmationDiv.removeClass('active');
        $overlayDiv.removeClass('active-overlay');
        $confirmationDiv.find('.add-to-cart-additional-content').empty();
        this.confirmationShown = false;
    },

    /**
     * @function
     * @description Removes a product from cart and shows updated mini cart
     * @param {Object} $target the click target
     */
    removeFromCart: function ($target) {
        var uuid = $target.data('uuid');
        var url = util.ajaxUrl($target.hasClass('giftcert-item') ? Urls.removeGiftCertificate : Urls.removeProduct);
        var data;

        if (uuid !== undefined) {
            data = {uuid: uuid};
            var productContainer = $target.closest('li.mini-cart-product');
            var productData = dytracking.getProductData(productContainer);
            productData.currency = $('input[name="cartCurrency"]').val();
            productData.value = productContainer.find('input[name="priceTotal"]').val();

            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                success: function (response) {
                    const chunks = response.split(util.contentSplitter);
                    try {
                        const data = JSON.parse(chunks[1]);
                        if (data?.removeProductTrackingData) {
                            window?.dataLayer?.push(data.removeProductTrackingData);
                        }
                    } catch (e) {}
                    minicart.show(chunks[0]);
                    dytracking.trackMiniCartRemove(productData);
                    initializeMiniCartRemoval();
                }
            });
        }
    },

    /**
     * @function
     * @description Update the mobile header cart qty
     * @param {Number} Cart quantity
     */
    updateMobileQty: function (qty) {
        var $qty = $('.header-mobile-minicart > .qty');

        if (!$qty || $qty.length == 0) {
            $('.header-mobile-minicart').append('<span class="qty"></span>');
            $qty = $('.header-mobile-minicart > .qty');
        }

        if (qty && qty > 0) {
            $qty.html(qty);
        } else {
            $qty.empty();
        }
    }
};

module.exports = minicart;
